module.exports = __webpack_public_path__ + "static/img/download.1da94714.png";